const pillarsPt = [
  {
    id: "publicar",
    num: "I",
    name: "Publicar",
    interest: "publicar",
    via: "Através do selo Editora Quitanda",
    short: "Livros e publicações que dão forma duradoura ao que a instituição construiu.",
    problem:
      "Toda a instituição acumula saber: estudos, decisões, trajectórias de décadas. Publicar dá-lhe forma permanente, com o rigor e o acabamento que esse percurso merece.",
    deliver: [
      "Livros institucionais",
      "Coffee table books",
      "Relatórios de impacto",
      "Revistas académicas",
      "Publicações comemorativas",
    ],
  },
  {
    id: "visivel",
    num: "II",
    name: "Tornar visível",
    interest: "tecnologia",
    via: "Tecnologia para instituições",
    short: "Tecnologia que organiza, indexa e projecta o conhecimento da instituição.",
    problem:
      "O conhecimento que a instituição já produz ganha alcance quando está organizado, acessível e indexado. A tecnologia certa leva-o mais longe, preservando a sua essência.",
    deliver: [
      "Automações e integrações de IA",
      "Desenvolvimento de sistemas de gestão",
      "Criação de repositórios e bibliotecas digitais",
    ],
  },
  {
    id: "capacitar",
    num: "III",
    name: "Capacitar",
    interest: "formacao",
    via: "Através da TRIA Academy",
    short: "Formação executiva e programas educacionais através da TRIA Academy.",
    problem:
      "As equipas já trazem experiência e critério. A formação certa converte essa experiência em liderança preparada para os dados e a inteligência artificial.",
    deliver: [
      "Formação executiva — ex.: liderança com dados e inteligência artificial",
      "Programas educacionais para instituições",
    ],
  },
];

const pillarsEn = [
  {
    ...pillarsPt[0],
    name: "Publish",
    via: "Through the Editora Quitanda imprint",
    short: "Books and publications that give lasting form to what the institution has built.",
    problem:
      "Every institution accumulates knowledge: studies, decisions, decades of trajectory. Publishing gives it permanent form, with the rigour and finish that journey deserves.",
    deliver: [
      "Institutional books",
      "Coffee table books",
      "Impact reports",
      "Academic journals",
      "Commemorative publications",
    ],
  },
  {
    ...pillarsPt[1],
    name: "Make visible",
    via: "Technology for institutions",
    short: "Technology that organises, indexes and projects the institution's knowledge.",
    problem:
      "The knowledge an institution already produces gains reach when it is organised, accessible and indexed. The right technology carries it further while preserving its essence.",
    deliver: [
      "AI automations and integrations",
      "Management systems development",
      "Building repositories and digital libraries",
    ],
  },
  {
    ...pillarsPt[2],
    name: "Empower",
    via: "Through TRIA Academy",
    short: "Executive education and educational programmes through TRIA Academy.",
    problem:
      "Teams already bring experience and judgement. The right training turns that experience into leadership prepared for data and artificial intelligence.",
    deliver: [
      "Executive education — e.g. leadership with data and artificial intelligence",
      "Educational programmes for institutions",
    ],
  },
];

const books = [
  { title: "Quão africano é o cristianismo?" },
  { title: "Cristianismo e África", box: true },
  { title: "Hermenêutica Africana" },
  { title: "O Estigma da Cor" },
  { title: "Martin Luther King Jr. Revisitado" },
  { title: "Um Coração Sábio" },
  { title: "O Cabelo de Joyce e o Espírito Santo" },
];

const actsPt = [
  { num: "I", name: "Escuta", text: "Antes de propor, ouvimos. Mergulhamos na instituição para compreender os seus processos, as suas pessoas, a sua história e os seus objectivos. O resultado é um diagnóstico claro do ponto de partida e do que precisa de ser construído." },
  { num: "II", name: "Arquitectura", text: "Desenhamos a solução antes de a produzir. Definimos o âmbito, as etapas, os responsáveis e os critérios de sucesso, seja um sistema, um programa de formação ou uma obra editorial. Nada avança sem um plano aprovado pela instituição." },
  { num: "III", name: "Construção", text: "Transformamos o plano em entrega. Desenvolvemos e configuramos plataformas, produzimos conteúdos e materiais formativos, pesquisamos, escrevemos e editamos. Cada etapa é validada com a instituição, para garantir rigor e fidelidade ao que foi desenhado." },
  { num: "IV", name: "Implementação", text: "Colocamos a solução em uso real. Sistemas entram em funcionamento com os utilizadores formados, programas chegam às turmas e obras são lançadas, distribuídas e integradas no acervo da instituição. É aqui que o projecto deixa de ser intenção e passa a ser prática." },
  { num: "V", name: "Sustentação", text: "Garantimos que o que foi construído continua a funcionar e a crescer. Asseguramos suporte e actualização, formamos equipas internas para dar continuidade e medimos o impacto alcançado. Cada projecto termina com uma prova concreta do valor entregue." },
];
const actsEn = [
  { num: "I", name: "Listening", text: "Before proposing, we listen. We immerse ourselves in the institution to understand its processes, its people, its history and its goals. The result is a clear diagnosis of the starting point and of what needs to be built." },
  { num: "II", name: "Architecture", text: "We design the solution before producing it. We define the scope, stages, owners and success criteria, whether for a system, a training programme or an editorial work. Nothing moves forward without a plan approved by the institution." },
  { num: "III", name: "Construction", text: "We turn the plan into delivery. We develop and configure platforms, produce content and training materials, research, write and edit. Each stage is validated with the institution to ensure rigour and fidelity to the design." },
  { num: "IV", name: "Implementation", text: "We put the solution into real use. Systems go live with trained users, programmes reach their classes, and works are launched, distributed and added to the institution's collection. This is where the project stops being an intention and becomes practice." },
  { num: "V", name: "Sustainment", text: "We make sure what was built keeps working and growing. We provide support and updates, train internal teams to ensure continuity and measure the impact achieved. Every project ends with concrete proof of the value delivered." },
];

export const content = {
  pt: {
    nav: {
      home: "Início",
      about: "Quem somos",
      what: "O que fazemos",
      quitanda: "Editora Quitanda",
      method: "Método Construtor",
      contact: "Contacto",
      cta: "Agendar conversa",
      menu: "Menu",
      close: "Fechar",
    },
    seo: {
      home: ["TRIA — Conhecimento que se prova", "A TRIA transforma o conhecimento de instituições, empresas e líderes em livros, plataformas e pessoas capacitadas. Angola e Brasil."],
      about: ["Quem somos — TRIA", "A TRIA é um grupo de infraestrutura intelectual com presença em Luanda e São Paulo: tecnologia, educação e edição para instituições."],
      what: ["O que fazemos — TRIA", "Publicar, tornar visível e capacitar: os três pilares da TRIA para instituições em Angola e no Brasil."],
      quitanda: ["Editora Quitanda — um selo TRIA", "Selo editorial premium na intersecção entre identidade africana, vida intelectual cristã e excelência editorial."],
      method: ["Método Construtor — TRIA", "A metodologia própria da TRIA: um ciclo de cinco actos."],
      contact: ["Contacto — TRIA", "Agende uma conversa com a TRIA: presencial em Luanda ou São Paulo, ou online."],
    },
    hero: {
      eyebrow: "Infraestrutura intelectual · Angola — Brasil",
      lines: ["Conhecimento", "que se prova."],
      sub: "Transformamos o conhecimento que a sua instituição já produz em algo visível, publicado e verificável.",
      inst: "Para instituições",
      auth: "Para autores",
      scroll: "A tese",
    },
    creds: {
      eyebrow: "Credenciais",
      items: [
        { big: "+400", label: "livros produzidos" },
        { big: "+150", label: "títulos em catálogo próprio" },
        { big: "4", label: "países de distribuição: Brasil, Angola, Portugal e EUA" },
        { big: "Imprensa", label: "trabalho editorial destacado na TV Globo, Estadão e Folha de S.Paulo" },
      ],
    },
    marquee: ["Livros", "Repositórios", "Plataformas", "Pessoas capacitadas"],
    pillarsIntro: {
      eyebrow: "O que fazemos",
      title: "Três pilares. Uma só infraestrutura de credibilidade.",
      text: "O que se publica ganha visibilidade. O que é visível forma pessoas. Quem se forma produz novo conhecimento.",
      more: "Ver o pilar",
    },
    pillars: pillarsPt,
    quitandaBlock: {
      eyebrow: "O selo editorial",
      sig: "um selo TRIA",
      text: "Um selo premium na intersecção entre identidade africana, vida intelectual cristã e excelência editorial.",
      link: "Conhecer a Quitanda",
    },
    cta: {
      eyebrow: "Próximo passo",
      title: "Agende uma conversa",
      sub: "Presencial em Luanda ou São Paulo, ou online.",
      btn: "Agendar conversa",
    },
    whatPage: {
      eyebrow: "O que fazemos",
      lines: ["Elevamos o que", "a instituição já faz."],
      intro: "Três pilares que se reforçam mutuamente. Cada um parte do conhecimento que já existe e dá-lhe forma, alcance e continuidade.",
      problemLabel: "O ponto de partida",
      deliverLabel: "O que entregamos",
      talk: "Conversar sobre este pilar",
    },
    quitandaPage: {
      eyebrow: "Selo editorial",
      positioning: "Um selo editorial premium na intersecção entre identidade africana, vida intelectual cristã e excelência editorial.",
      credsTitle: "Credenciais",
      creds: [
        "Editora dos livros de The Chosen no Brasil",
        "Parceria de distribuição com a HarperCollins",
        "Parceira oficial da Amazon — papel, e-book e audiolivro",
        "Cerca de 80% do catálogo também em audiolivro e e-book",
        "Livros usados como fonte por grupos de investigação em universidades federais",
      ],
      booksTitle: "Títulos em destaque",
      booksNote: "[Capas ilustrativas — substituir pelas capas reais dos livros]",
      box: "Box",
      authorsTitle: "Para autores",
      authorsIntro: "Do manuscrito à presença internacional, com rigor editorial e académico.",
      authors: [
        { t: "Edição completa", d: "Do manuscrito ao livro impresso e digital." },
        { t: "Edição e indexação académica", d: "ISBN, ficha catalográfica, ORCID e Google Scholar." },
        { t: "E-books na Amazon", d: "Publicação e posicionamento de e-books na Amazon." },
      ],
      authorsCta: "Falar sobre o meu livro",
      instTitle: "Para instituições",
      instText: "Para livros institucionais, relatórios e publicações comemorativas, a Quitanda trabalha dentro do pilar Publicar.",
      instLink: "Ver o pilar Publicar",
      store: "Visitar a loja Quitanda",
    },
    methodPage: {
      eyebrow: "Metodologia",
      lines: ["Método", "Construtor."],
      intro: "A metodologia própria da TRIA: um ciclo de cinco actos.",
      act: "Acto",
      acts: actsPt,
    },
    contactPage: {
      eyebrow: "Contacto",
      lines: ["Conversemos."],
      intro: "As reuniões podem ser presenciais, em Luanda ou São Paulo, ou online — como for mais conveniente para si.",
      offices: [
        { city: "Luanda", addr: ["Avenida Pedro de Castro Van-Dúnem", "Torre C, Porta C01, R/C", "Talatona"], photo: "[FOTO — Escritório de Luanda]" },
        { city: "São Paulo", addr: ["Avenida Giovanni Gronchi, 6675", "Morumbi"], photo: "[FOTO — Escritório de São Paulo]" },
      ],
      modes: "Presencial ou online",
      emailLabel: "E-mail",
      form: {
        title: "Pedido de conversa",
        name: "Nome",
        institution: "Instituição",
        role: "Cargo",
        email: "E-mail",
        interest: "Interesse",
        format: "Formato preferido",
        message: "Mensagem (opcional)",
        interests: { publicar: "Publicar", tecnologia: "Tecnologia", formacao: "Formação", autor: "Autor" },
        formats: { luanda: "Presencial · Luanda", saopaulo: "Presencial · São Paulo", online: "Online" },
        submit: "Enviar pedido",
        sending: "A enviar…",
        ok: "Pedido recebido. Entraremos em contacto em breve.",
        err: "Não foi possível enviar. Escreva-nos para geral@triacompany.com.",
        required: "Preencha nome, instituição, cargo, e-mail e interesse.",
      },
    },
    footer: {
      thesis: "Conhecimento que se prova.",
      seal: "Editora Quitanda — um selo TRIA",
      rights: "Todos os direitos reservados.",
    },
    wa: "Conversar no WhatsApp",
  },
  en: {
    nav: {
      home: "Home",
      about: "Who we are",
      what: "What we do",
      quitanda: "Editora Quitanda",
      method: "Constructor Method",
      contact: "Contact",
      cta: "Book a conversation",
      menu: "Menu",
      close: "Close",
    },
    seo: {
      home: ["TRIA — Knowledge that proves itself", "TRIA turns the knowledge of institutions, companies and leaders into books, platforms and capable people. Angola and Brazil."],
      about: ["Who we are — TRIA", "TRIA is an intellectual infrastructure group in Luanda and São Paulo: technology, education and publishing for institutions."],
      what: ["What we do — TRIA", "Publish, make visible and empower: TRIA's three pillars for institutions in Angola and Brazil."],
      quitanda: ["Editora Quitanda — a TRIA imprint", "A premium imprint at the intersection of African identity, Christian intellectual life and editorial excellence."],
      method: ["Constructor Method — TRIA", "TRIA's own methodology: a cycle of five acts."],
      contact: ["Contact — TRIA", "Book a conversation with TRIA: in person in Luanda or São Paulo, or online."],
    },
    hero: {
      eyebrow: "Intellectual infrastructure · Angola — Brazil",
      lines: ["Knowledge", "that proves itself."],
      sub: "We turn the knowledge your institution already produces into something visible, published and verifiable.",
      inst: "For institutions",
      auth: "For authors",
      scroll: "The thesis",
    },
    creds: {
      eyebrow: "Credentials",
      items: [
        { big: "400+", label: "books produced" },
        { big: "150+", label: "titles in our own catalogue" },
        { big: "4", label: "distribution countries: Brazil, Angola, Portugal and USA" },
        { big: "Press", label: "editorial work featured on TV Globo, Estadão and Folha de S.Paulo" },
      ],
    },
    marquee: ["Books", "Repositories", "Platforms", "Capable people"],
    pillarsIntro: {
      eyebrow: "What we do",
      title: "Three pillars. One infrastructure of credibility.",
      text: "What is published gains visibility. What is visible shapes people. Those who learn produce new knowledge.",
      more: "See the pillar",
    },
    pillars: pillarsEn,
    quitandaBlock: {
      eyebrow: "The imprint",
      sig: "a TRIA imprint",
      text: "A premium imprint at the intersection of African identity, Christian intellectual life and editorial excellence.",
      link: "Discover Quitanda",
    },
    cta: {
      eyebrow: "Next step",
      title: "Book a conversation",
      sub: "In person in Luanda or São Paulo, or online.",
      btn: "Book a conversation",
    },
    whatPage: {
      eyebrow: "What we do",
      lines: ["We elevate what", "institutions already do."],
      intro: "Three mutually reinforcing pillars. Each starts from knowledge that already exists and gives it form, reach and continuity.",
      problemLabel: "The starting point",
      deliverLabel: "What we deliver",
      talk: "Talk about this pillar",
    },
    quitandaPage: {
      eyebrow: "Editorial imprint",
      positioning: "A premium editorial imprint at the intersection of African identity, Christian intellectual life and editorial excellence.",
      credsTitle: "Credentials",
      creds: [
        "Publisher of The Chosen books in Brazil",
        "Distribution partnership with HarperCollins",
        "Official Amazon partner — print, e-book and audiobook",
        "Around 80% of the catalogue also in audiobook and e-book",
        "Books used as sources by research groups at Brazilian federal universities",
      ],
      booksTitle: "Featured titles",
      booksNote: "[Illustrative covers — replace with the real book covers]",
      box: "Box set",
      authorsTitle: "For authors",
      authorsIntro: "From manuscript to international presence, with editorial and academic rigour.",
      authors: [
        { t: "Full publishing", d: "From manuscript to printed and digital book." },
        { t: "Academic editing and indexing", d: "ISBN, cataloguing record, ORCID and Google Scholar." },
        { t: "E-books on Amazon", d: "Publishing and positioning e-books on Amazon." },
      ],
      authorsCta: "Talk about my book",
      instTitle: "For institutions",
      instText: "For institutional books, reports and commemorative publications, Quitanda works within the Publish pillar.",
      instLink: "See the Publish pillar",
      store: "Visit the Quitanda store",
    },
    methodPage: {
      eyebrow: "Methodology",
      lines: ["Constructor", "Method."],
      intro: "TRIA's own methodology: a cycle of five acts.",
      act: "Act",
      acts: actsEn,
    },
    contactPage: {
      eyebrow: "Contact",
      lines: ["Let's talk."],
      intro: "Meetings can be in person, in Luanda or São Paulo, or online — whichever suits you best.",
      offices: [
        { city: "Luanda", addr: ["Avenida Pedro de Castro Van-Dúnem", "Torre C, Porta C01, R/C", "Talatona"], photo: "[PHOTO — Luanda office]" },
        { city: "São Paulo", addr: ["Avenida Giovanni Gronchi, 6675", "Morumbi"], photo: "[PHOTO — São Paulo office]" },
      ],
      modes: "In person or online",
      emailLabel: "Email",
      form: {
        title: "Conversation request",
        name: "Name",
        institution: "Institution",
        role: "Position",
        email: "Email",
        interest: "Interest",
        format: "Preferred format",
        message: "Message (optional)",
        interests: { publicar: "Publish", tecnologia: "Technology", formacao: "Training", autor: "Author" },
        formats: { luanda: "In person · Luanda", saopaulo: "In person · São Paulo", online: "Online" },
        submit: "Send request",
        sending: "Sending…",
        ok: "Request received. We will be in touch shortly.",
        err: "We could not send it. Write to us at geral@triacompany.com.",
        required: "Please fill in name, institution, position, email and interest.",
      },
    },
    footer: {
      thesis: "Knowledge that proves itself.",
      seal: "Editora Quitanda — a TRIA imprint",
      rights: "All rights reserved.",
    },
    wa: "Chat on WhatsApp",
  },
};

export { books };

export const about = {
  pt: {
    eyebrow: "Quem somos",
    lines: ["Quem", "somos."],
    intro: "A TRIA é um grupo de infraestrutura intelectual com presença em Luanda e São Paulo. Nasceu com um propósito claro: garantir que o conhecimento produzido pelas instituições ganha visibilidade, é aplicado e permanece no tempo.",
    frontsLead: "Para isso, a TRIA reúne três frentes complementares.",
    fronts: [
      { t: "Tecnologia", d: "Desenvolve e implementa plataformas digitais: bibliotecas digitais, repositórios académicos, sistemas de gestão e de autoavaliação institucional, plataformas de visibilidade académica e soluções de cobrança digital." },
      { t: "Educação", d: "Forma líderes e equipas através da TRIA Academy." },
      { t: "Editorial e memória", d: "Publica através da Editora Quitanda, o seu selo editorial, com mais de 400 livros produzidos e distribuição em cinco países." },
    ],
    distinct: "O que distingue a TRIA não é apenas a diversidade das suas soluções, mas a forma como se ligam.",
    distinctBody: "Cada projecto parte do conhecimento que a instituição já possui e transforma-o em resultados concretos: processos digitalizados, informação organizada e acessível, equipas preparadas para aplicar o que sabem e obras que registam a sua história e o seu impacto.",
    methodLabel: "Método Construtor",
    method: "Através de um método próprio, o Método Construtor, a TRIA conduz cada projecto da escuta inicial ao desenho da solução, da implementação ao suporte contínuo. Garante que cada sistema entra em funcionamento, cada programa chega às pessoas certas e cada obra cumpre o seu propósito. Alia capacidade tecnológica, rigor editorial e uma compreensão profunda dos contextos angolano e brasileiro.",
    methodLink: "Conhecer o Método",
    closing: "A TRIA é infraestrutura intelectual para instituições que querem demonstrar o valor do que sabem.",
    thesis: "Conhecimento que se prova.",
  },
  en: {
    eyebrow: "Who we are",
    lines: ["Who", "we are."],
    intro: "TRIA is an intellectual infrastructure group with a presence in Luanda and São Paulo. It was born with a clear purpose: to ensure that the knowledge institutions produce gains visibility, is applied and endures over time.",
    frontsLead: "To do so, TRIA brings together three complementary fronts.",
    fronts: [
      { t: "Technology", d: "Develops and implements digital platforms: digital libraries, academic repositories, management and institutional self-assessment systems, academic visibility platforms and digital payment solutions." },
      { t: "Education", d: "Trains leaders and teams through TRIA Academy." },
      { t: "Publishing and memory", d: "Publishes through Editora Quitanda, its editorial imprint, with more than 400 books produced and distribution in five countries." },
    ],
    distinct: "What sets TRIA apart is not only the range of its solutions, but the way they connect.",
    distinctBody: "Every project starts from the knowledge the institution already holds and turns it into concrete results: digitised processes, organised and accessible information, teams prepared to apply what they know, and works that record their history and impact.",
    methodLabel: "Constructor Method",
    method: "Through its own methodology, the Constructor Method, TRIA guides each project from initial listening to solution design, from implementation to ongoing support. It ensures every system goes live, every programme reaches the right people and every work fulfils its purpose. It combines technological capability, editorial rigour and a deep understanding of the Angolan and Brazilian contexts.",
    methodLink: "Discover the Method",
    closing: "TRIA is intellectual infrastructure for institutions that want to demonstrate the value of what they know.",
    thesis: "Knowledge that proves itself.",
  },
};
